import MenuItem from "@mui/material/MenuItem";
import React from "react";
import { useHistory } from "react-router-dom";
import { MenuItemObjectType } from "./MenuType";

type MenuItemComponentPropsType = {
	value: MenuItemObjectType;
	handleClose: () => void;
};
function MenuItemComponent({ value, handleClose }: MenuItemComponentPropsType) {
	const history = useHistory();
	return (
		<MenuItem
			disableRipple
			onClick={() => {
				handleClose();
				history.push(value.path);
			}}
		>
			<span style={{ fontWeight: "bold" }}>{value.title}</span>
		</MenuItem>
	);
}

export default MenuItemComponent;
